import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "../../../Translation";
import Badge from "../../Badge";
import { ArrowDownIcon, ArrowsPointingOutIcon, ChevronDownIcon, Cog8ToothIcon, DocumentIcon, ExclamationCircleIcon, MinusIcon, PlusIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import { webhook } from "../../../Resources/Images";
import { TextInput } from "../../Inputs/TextInput";
import { TextArea } from "../../Inputs/TextArea";
import { Button } from "../../Buttons";
import Tabs, { useTabs } from "../../Tabs";
import { useAPI } from "../../../API";
import Select from "../../Inputs/Select";
import { bgColor, hoverBgColor } from "../../../Resources/CSS/styling";
import { textColor } from "../../../Resources/CSS/styling";
const ConfigurationTab = ({ tmpStep, setTmpStep, save, error, isCreate }) => {

    const { translate } = useTranslation();
    const api = useAPI();

      // Function to clean JSON string by removing escaped quotes and newlines
      const cleanJsonString = (jsonString) => {
        if (typeof jsonString !== 'string') return jsonString;
        
        return jsonString.replace(/\\n/g, '\n').replace(/\\"/g, '');
    };

    const [bodyString, setBodyString] = useState(cleanJsonString(tmpStep.data.body));

    const addHeader = () => {
        var keyIndex = 0;
        while (headers.some(header => header.key === `key_${keyIndex}`)) {
            keyIndex++;
        }

        tmpStep.data.headers[`key_${keyIndex}`] = 'value';
        setTmpStep({ ...tmpStep });
    }

    const removeHeader = (key) => {
        delete tmpStep.data.headers[key];
        setTmpStep({ ...tmpStep });
    }

    const headers = useMemo(() => Object.keys(tmpStep.data.headers).map(key => ({
        key: key,
        value: tmpStep.data.headers[key]
    })), [tmpStep]);

    const updateMethod = (method) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, method: method } });
    }

    const updateHeader = (key, updateKey, value) => {

        if (updateKey) {
            const oldValue = tmpStep.data.headers[key];
            delete tmpStep.data.headers[key];
            tmpStep.data.headers[value] = oldValue;
        } else {
            tmpStep.data.headers[key] = value;
        }
        setTmpStep({ ...tmpStep });
    }

    const onBodyChange = (body) => {
        try {
            // const parsedBody = JSON.parse(body);
            setTmpStep({ ...tmpStep, data: { ...tmpStep.data, body: body } });
            setBodyString(body);
        } catch (e) {
            return;
        }
    }

    const updateUrl = (url) => {
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, url: url } });
    }

    return (
        <div className="flex flex-col mt-4">

            {error && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{error}</p>}

            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.method')}</p>
            <div className="flex flex-row gap-2">
                <Badge onClick={() => updateMethod("GET")} text={"GET"} color={tmpStep.data.method === "GET" ? "green" : "gray"} withoutRemove={true} className={`${tmpStep.data.method === "GET" ? "opacity-100" : "opacity-50"} cursor-pointer`} />
                <Badge onClick={() => updateMethod("POST")} text={"POST"} color={tmpStep.data.method === "POST" ? "yellow" : "gray"} withoutRemove={true} className={`${tmpStep.data.method === "POST" ? "opacity-100" : "opacity-50"} cursor-pointer`} />
                <Badge onClick={() => updateMethod("PUT")} text={"PUT"} color={tmpStep.data.method === "PUT" ? "blue" : "gray"} withoutRemove={true} className={`${tmpStep.data.method === "PUT" ? "opacity-100" : "opacity-50"} cursor-pointer`} />
                <Badge onClick={() => updateMethod("DELETE")} text={"DELETE"} color={tmpStep.data.method === "DELETE" ? "red" : "gray"} withoutRemove={true} className={`${tmpStep.data.method === "DELETE" ? "opacity-100" : "opacity-50"} cursor-pointer`} />
            </div>


            <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.url')}</p>
            <TextInput value={tmpStep.data.url} onChange={(e) => {
                updateUrl(e.target.value);
            }} />

            <div className="flex flex-row mt-2 items-center justify-between">
                <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.headers')}</p>
                <PlusIcon onClick={addHeader} className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-300" />
            </div>

            {headers.map((header, index) => (
                <div className="flex flex-row w-full flex-1 items-center">
                    <div className="flex w-32">
                        <TextInput value={header.key} onChange={(e) => {
                            updateHeader(header.key, true, e.target.value);
                        }} />
                    </div>
                    <div className="flex flex-1 w-full flex-col ml-2">
                        <TextInput value={header.value} onChange={(e) => {
                            updateHeader(header.key, false, e.target.value);
                        }} />
                    </div>
                    <MinusIcon onClick={() => removeHeader(header.key)} className="w-6 h-6 text-red-600 cursor-pointer ml-2 hover:text-red-300" />
                </div>
            ))}

            {tmpStep.data.method !== "GET" && <div>
                <div className="flex flex-row items-center">
                    <p className="text-xl text-gray-600 font-bold mt-2 ">{translate('automatisation.body')}</p>
                </div>
                <TextArea rows={20} value={bodyString} onChange={(e) => onBodyChange(e.target.value)} />
            </div>}

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, bodyString)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const DescriptionTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();
    return (
        <div className="flex flex-col mt-4">
            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.description')}</p>
            <TextArea rows={5} value={tmpStep.description} onChange={(e) => setTmpStep({ ...tmpStep, description: e.target.value })} />

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, tmpStep.data.body)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const MappingTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();

    const mapping = tmpStep.data.extract_variables;

    const removeMapping = (extractVariable) => {
        const newMapping = mapping.filter(mapping => mapping !== extractVariable);
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, extract_variables: newMapping } });
    }

    const addMapping = () => {
        const newMapping = mapping ? [...mapping, { from: '', to: '' }] : [{ from: '', to: '' }];
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, extract_variables: newMapping } });
    }

    const updateMapping = (extractVariable, key, value) => {
        const newMapping = [...mapping];
        newMapping[newMapping.indexOf(extractVariable)][key] = value;
        setTmpStep({ ...tmpStep, data: { ...tmpStep.data, extract_variables: newMapping } });
    }

    const toOptions = [
        { id: 1, name: translate('automatisation.from_event'), value: 'event' },
        { id: 2, name: translate('automatisation.from_contact'), value: 'contact' },
        { id: 3, name: translate('automatisation.from_global'), value: 'global' }
    ]

    const toOptionSelected = (extractVariable) => toOptions.find(option => extractVariable.to.startsWith(option.value)) || toOptions[0];

    const toWithoutVariableSource = (extractVariable) => {
        if (extractVariable.to.startsWith('event')) {
            return extractVariable.to.substring(6) || '';
        } else if (extractVariable.to.startsWith('contact')) {
            return extractVariable.to.substring(8) || '';
        } else if (extractVariable.to.startsWith('global')) {
            return extractVariable.to.substring(7) || '';
        }
        return '';
    }

    return (
        <div className="flex flex-col mt-4 min-h-screen">
            <div className="flex flex-row mt-2 items-center justify-between">
                <p className="text-xl text-gray-600 font-bold mt-2">{translate('automatisation.mapping')}</p>
                <PlusIcon onClick={addMapping} className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-300" />
            </div>

            <div className="flex flex-col w-full flex-1 gap-4 mt-8">
                {mapping?.map((extractVariable, index) => (
                    <div className="w-full flex flex-col w-full border-2 border-gray-100 rounded-md p-4">
                        <div className="flex flex-row items-center justify-between">
                            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.from')}</p>
                            <MinusIcon onClick={() => removeMapping(extractVariable)} className="w-6 h-6 text-red-600 cursor-pointer ml-2 hover:text-red-300" />
                        </div>
                        <div className="flex flex-1 w-full flex-col">
                            <TextInput value={extractVariable.from} onChange={(e) => updateMapping(extractVariable, 'from', e.target.value)} />
                        </div>
                        <p className="text-xl text-gray-600 font-bold mt-4">{translate('automatisation.to')}</p>
                        <div className="flex flex-1 w-full flex-col">
                            <Select options={toOptions} selected={toOptionSelected(extractVariable)} setSelected={(toOption) => updateMapping(extractVariable, 'to', toOption.value + '.' + toWithoutVariableSource(extractVariable))} />
                            <TextInput value={toWithoutVariableSource(extractVariable)} onChange={(e) => updateMapping(extractVariable, 'to', toOptionSelected(extractVariable).value + "." + e.target.value)} />
                        </div>
                    </div>
                ))}
            </div>
            

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-col">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep, tmpStep.data.body)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default function APICallPanel({ setStepToClone, panelHook, step, refresh, deleteStep, isCreate, onCreateNewStep }) {
    const { translate } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [tmpStep, setTmpStep] = useState({ ...step });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const api = useAPI();

    const tabs = useTabs([
        { icon: Cog8ToothIcon, name: translate('automatisation.configuration'), current: true },
        { icon: DocumentIcon, name: translate('automatisation.description'), current: false },
        { icon: TableCellsIcon, name: translate('automatisation.mapping'), current: false }
    ]);

    // Reset tmpStep when panel is closed
    useEffect(() => {
        if (!panelHook.open) {
            setTmpStep({ ...step });
        }
    }, [panelHook.open]);

    const save = async (tmpStep, bodyString) => {


        try {
            // const parsedBody = JSON.parse(bodyString); We don't parse the body because it can be an invalid JSON until variable are applied

            const step = {
                ...tmpStep,
                data: {
                    ...tmpStep.data,
                    headers: tmpStep.data.headers,
                    url: tmpStep.data.url,
                    method: tmpStep.data.method,
                    body: bodyString
                }
            }

            console.log(bodyString);
            console.log(step);

            if (isCreate) {
                try {

                    if (!step.description || step.description.trim() === '') {
                        step.description = step.data.method + ' ' + step.data.url;
                    }

                    const newStepResponse = await api.createAutomatisationStep(tmpStep.automatisation_id, step);
                    if (newStepResponse?.data?.automatisation_step) {
                        await onCreateNewStep(newStepResponse.data.automatisation_step);
                    }
                } catch (e) {}
                
            } else {
                await api.updateAutomatisationStep(tmpStep.automatisation_id, step);
            }

            panelHook.setOpen(false);
            setTimeout(() => {
                refresh();
            }, 1000);
        } catch (e) {
            setError('Invalid JSON');
            return;
        }

    }

    const selectStepToClone = (step) => {
        setStepToClone(step);
        panelHook.setOpen(false);
    }


    return (
        <div className="flex flex-col flex-1 h-min rounded-md p-4 bg-white overflow-hidden">
            <div className="flex flex-row items-center">
                <img src={webhook} alt="webhook" className={`w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md mr-2 ${textColor}`} />
                <h2 className="text-xl font-bold">{translate('automatisation.api_call')}</h2>
                <div className="flex flex-row flex-1 justify-end">

                {!isCreate && <Button className="bg-red-600 hover:bg-red-300 ml-4" onClick={deleteStep}>
                        {translate('delete')}
                    </Button>}
                {isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => save(tmpStep, tmpStep.data.body)}>{translate('create')}</Button>}
                {!isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => selectStepToClone(tmpStep)}>{translate('clone')}</Button>}

                </div>
            </div>

            <div className="flex flex-row overflow-x-scroll no-scrollbar">
                <Tabs tabs={tabs} />
            </div>

            {tabs.currentTabIndex === 0 && <ConfigurationTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
            {tabs.currentTabIndex === 1 && <DescriptionTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
            {tabs.currentTabIndex === 2 && <MappingTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
        </div>
    )
}